var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

import * as React from 'react';
import withPaddingAndMargin from '../withPaddingAndMargin';
var Card = withPaddingAndMargin(function (props) {
  var className = props.className,
      title = props.title,
      children = props.children,
      otherProps = _objectWithoutProperties(props, ['className', 'title', 'children']);

  var classNames = ['dd-card', className.trim()].filter(function (x) {
    return x;
  }).join(' ');
  return React.createElement('div', _extends({
    className: classNames
  }, otherProps), title && React.createElement('div', {
    className: 'dd-card-header'
  }, React.createElement('div', {
    className: 'dd-card-title-m'
  }, title)), children);
});
Card.Header = withPaddingAndMargin(function (props) {
  var className = props.className,
      flex = props.flex,
      otherProps = _objectWithoutProperties(props, ['className', 'flex']);

  var classNames = ['dd-card-header', flex && 'dd-card-header-flex', className.trim()].filter(function (x) {
    return x;
  }).join(' ');
  return React.createElement('div', _extends({
    className: classNames
  }, otherProps));
});
Card.Title = withPaddingAndMargin(function (props) {
  var className = props.className,
      otherProps = _objectWithoutProperties(props, ['className']);

  var classNames = ['dd-card-title-m', className.trim()].filter(function (x) {
    return x;
  }).join(' ');
  return React.createElement('div', _extends({
    className: classNames
  }, otherProps));
});
Card.Container = withPaddingAndMargin(function (props) {
  var className = props.className,
      otherProps = _objectWithoutProperties(props, ['className']);

  var classNames = ['dd-card-container', className.trim()].filter(function (x) {
    return x;
  }).join(' ');
  return React.createElement('div', _extends({
    className: classNames
  }, otherProps));
});
Card.Footer = withPaddingAndMargin(function (props) {
  var className = props.className,
      otherProps = _objectWithoutProperties(props, ['className']);

  var classNames = ['dd-card-footer', className.trim()].filter(function (x) {
    return x;
  }).join(' ');
  return React.createElement('div', _extends({
    className: classNames
  }, otherProps));
});
export default Card;